module.exports = __webpack_public_path__ + "media/images/talana-logo-white-6633a8bd.svg";